export type UploadSessionTarget = 'import_page' | 'import_grid' | 'attachment';
export type UploadSessionStatus =
    | 'in_progress'
    | 'finished'
    | 'aborted'
    | 'not_started'
    | 'used'
    | 'cleanup';

export interface UploadSession {
    created_at: string;
    file_name: string;
    file_size: number;
    finished_at: string | null;
    session_id: string;
    status: UploadSessionStatus;
    target: UploadSessionTarget;
}

export enum UploadSessionErrors {
    ValidationError = 'VALIDATION_ERROR',
    InvalidUploadSession = 'INVALID_UPLOAD_SESSION',
    MalformedUploadRequest = 'MALFORMED_UPLOAD_REQUEST',
    StorageUploadError = 'STORAGE_UPLOAD_ERROR',
    UploadSessionFileSizeLimit = 'UPLOAD_SESSION_FILE_SIZE_LIMIT',
    UploadSessionInProgressError = 'UPLOAD_SESSION_IN_PROGRESS_ERROR',
    UploadSessionLimitExceeded = 'UPLOAD_SESSION_LIMIT_EXCEEDED',
    WrongFileExtension = 'WRONG_FILE_EXTENSION',
    General = 'GENERAL',
}
